import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const FolderIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 20.551 16.619',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path
      d="M434.012,47.794h-7.488l-.98-1.948a2.362,2.362,0,0,0-2.11-1.3H418.6a2.358,2.358,0,0,0-2.358,2.358V58.388a2.777,2.777,0,0,0,2.777,2.777h15a2.777,2.777,0,0,0,2.778-2.777V50.571A2.777,2.777,0,0,0,434.012,47.794Z"
      transform="translate(-416.239 -44.546)"
    />
  </SvgIcon>
);

export default FolderIcon;
